import moment from 'moment';
import { createSelector } from 'reselect';

const getWeightTargetInfo = (state) => state.weightTarget.data.weightTargetInfo;

const getTargetAdjustment = (state) => state.weightTarget.data.targetAdjustment;

const getIsTargetWeightInfoLoading = (state: any) =>
state.weightTarget.view.isProcessingWeightReview;

export const getBodyWeightGraphData = (state) => state.weightTarget.data.bodyWeightGraphData;

export const getMinMaxDefault = (state) => state.weightTarget.data.minMaxDefault;

const getWeightTargetInfoFromGoalData = (state) => state.summaryDashboard.data.weeklyGoalData ? {
  milestone: state.summaryDashboard.data.weeklyGoalData.milestone,
  target: state.summaryDashboard.data.weeklyGoalData.target,
  currentWeight: state.summaryDashboard.data.weeklyGoalData.currentWeight,
} : {};

const getWeightTargetStep = (state) => (state.weightTarget.view.step);
const getIsChangingTarget = (state) => (state.weightTarget.view.isChangingTarget);
const getIsRemovingTarget = (state) => (state.weightTarget.view.isRemovingTarget);

export const getTargetInfo = createSelector(
    [getWeightTargetInfo],
    (weightTargetInfo) => weightTargetInfo && weightTargetInfo.target,
);

export const getTargetAdjustmentSelector = createSelector(
  [getTargetAdjustment],
  (targetInfo) => targetInfo && targetInfo.target,
);

export const getMilestoneInfo = createSelector(
    [getWeightTargetInfo],
    (weightTargetInfo) => weightTargetInfo && weightTargetInfo.milestone,
);

export const isTargetWeightInfoLoadingSelector = createSelector(
    [getIsTargetWeightInfoLoading],
    (isTargetWeightInfoLoading) => isTargetWeightInfoLoading,
  );

export const showMileStoneSelector = createSelector(
    [getWeightTargetInfo],
    (weightTargetInfo) => weightTargetInfo && !weightTargetInfo?.milestone?.reached,
  );

export const getMilestoneInfoFromBodyWeightGraphData = createSelector(
  [getBodyWeightGraphData],
  (bodyWeightGraphData) => bodyWeightGraphData?.data.find(x => x.isMileStone),
);

export const weightTargetInfoFromGoalSelector = createSelector(
  [getWeightTargetInfoFromGoalData], (weightTargetInfo) => {
    return weightTargetInfo.target;
  });

export const weightMilestoneInfoFromGoalSelector = createSelector(
  [getWeightTargetInfoFromGoalData], (weightTargetInfo) => {
    return weightTargetInfo.milestone;
  });

export const currentWeightInfoFromGoalSelector = createSelector(
  [getWeightTargetInfoFromGoalData], (weightTargetInfo) => {
    return weightTargetInfo.currentWeight &&  Number(weightTargetInfo.currentWeight.toFixed(1));
  });

export const weightTargetStepSelector = createSelector(
    [getWeightTargetStep],
    (weightTargetStep) => weightTargetStep,
);

export const isChangingTargetSelector = createSelector(
  [getIsChangingTarget],
  (isChangingTarget) => isChangingTarget,
);

export const isRemovingTargetSelector = createSelector(
  [getIsRemovingTarget],
  (isRemovingTarget) => isRemovingTarget,
);
